export default __webpack_public_path__ + "coinholio.animation.02.b3f3cfd5f86fb9e0df83e50bf93d38a9.webm";